/**
 * page-rivo-debug.js
 *
 * Debug wiring — API calls, button state, Rivo status, global inspector,
 * DOB update, and custom action proxy trigger.
 * Uses window.RivoAPI (Account Widget SDK) for all API calls.
 * Render functions live in page-rivo-debug-components.js.
 */

window.RivoDebug = (function () {
  var rivoReady = false;

  // ── Rivo status indicator ─────────────────────────
  function markRivoReady() {
    rivoReady = true;
    document.getElementById('rivo-status-dot').className = 'rivo-status__dot ready';
    document.getElementById('rivo-status-text').textContent = 'RivoAPI ready';
  }

  // RivoAPI is set by the Account Widget — check if already present,
  // otherwise poll briefly (widget may still be bootstrapping).
  if (window.RivoAPI) {
    markRivoReady();
  } else {
    document.addEventListener('rivo-js-loaded', markRivoReady);

    var pollCount = 0;
    var poll = setInterval(function () {
      pollCount++;
      if (window.RivoAPI) {
        clearInterval(poll);
        markRivoReady();
      } else if (pollCount >= 20) {
        clearInterval(poll);
        if (!rivoReady) {
          console.warn('[RivoDebug] Timed out. window.Rivo:', window.Rivo,
            '| window.RivoAPI:', window.RivoAPI,
            '| window.RivoJS:', window.RivoJS);
          document.getElementById('rivo-status-dot').className = 'rivo-status__dot error';
          document.getElementById('rivo-status-text').textContent =
            'RivoAPI not detected after 10 s — check console for details';
        }
      }
    }, 500);
  }

  // ── Shared helpers ────────────────────────────────
  function setJson(id, data, isError) {
    var el = document.getElementById(id);
    el.textContent = JSON.stringify(data, null, 2);
    el.className = 'rivo-debug__json' + (isError ? ' error' : '');
  }

  function setLoading(btn) {
    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = 'Running';
  }

  function resetBtn(btn, label) {
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.textContent = label || 'Run';
  }

  function copyJson(id) {
    var text = document.getElementById(id).textContent;
    navigator.clipboard.writeText(text).then(function () {
      var btn = document.querySelector('[onclick*="copyJson(\'' + id + '\')"]');
      if (btn) {
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = 'Copy JSON'; }, 1500);
      }
    });
  }

  function guardApi() {
    if (!window.RivoAPI) {
      alert('RivoAPI not ready yet — wait for the status indicator to go green.');
      return false;
    }
    return true;
  }

  // ── 1. identify_customer ──────────────────────────
  function runGetCustomerDetails(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.identify_customer('loggedin')
      .then(function (resp) {
        setJson('json-customer-details', resp);
        RivoDebugComponents.renderCustomerDetails(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-customer-details', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 2. customer_tier ──────────────────────────────
  function runGetVipTier(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.customer_tier('loggedin')
      .then(function (resp) {
        setJson('json-vip-tier', resp);
        RivoDebugComponents.renderVipTier(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-vip-tier', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 3. rewards ────────────────────────────────────
  function runGetShopRewards(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.rewards()
      .then(function (resp) {
        var rewards = Array.isArray(resp) ? resp : (resp.rewards || resp);
        setJson('json-shop-rewards', rewards);
        RivoDebugComponents.renderShopRewards(rewards);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-shop-rewards', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  function testRedeem(rewardId, btn) {
    if (!guardApi()) return;
    var result = document.getElementById('redemption-result');
    btn.disabled = true;
    btn.textContent = '…';
    result.className = 'rivo-redemption-result';
    result.innerHTML = '';

    RivoAPI.redeem(rewardId, 'loggedin')
      .then(function (data) {
        var code = (data && (data.code || data.discount_code)) || null;
        if (code) {
          result.className = 'rivo-redemption-result success';
          result.innerHTML =
            '✅ Lunastus onnistui!' +
            '<div class="rivo-redemption-result__code">' + code + '</div>' +
            '<div style="font-size:12px;margin-top:4px;">Käytä koodi kassalla.</div>';
        } else {
          result.className = 'rivo-redemption-result success';
          result.innerHTML =
            '✅ Lunastus onnistui. Täysi vastaus yllä JSON:ssa.' +
            '<pre style="font-size:11px;margin-top:6px;white-space:pre-wrap;">' +
            JSON.stringify(data, null, 2) + '</pre>';
        }
        btn.textContent = 'Lunasta';
        btn.disabled = false;
      })
      .catch(function (err) {
        result.className = 'rivo-redemption-result error';
        result.innerHTML = '❌ Lunastus epäonnistui: ' + (err.message || String(err));
        btn.textContent = 'Lunasta';
        btn.disabled = false;
      });
  }

  // ── 6. window.Rivo global inspector ──────────────
  function runInspectGlobal(btn) {
    if (!window.Rivo) {
      var el = document.getElementById('json-rivo-global');
      el.textContent = 'window.Rivo is not defined — is Rivo installed on this page?';
      el.className = 'rivo-debug__json error';
      return;
    }
    setLoading(btn);
    setTimeout(function () {
      try {
        var dump = {
          global_config: window.Rivo.global_config || null,
          common: window.Rivo.common || null,
          loy_config: window.Rivo.loy_config || null,
          RivoAPI_methods: window.RivoAPI ? Object.keys(window.RivoAPI) : 'not loaded',
          keys: Object.keys(window.Rivo),
        };
        setJson('json-rivo-global', dump);

        var gc = window.Rivo.global_config || {};
        var cm = window.Rivo.common || {};
        var cu = cm.customer || {};
        var proxy = (gc.proxy_paths && gc.proxy_paths.loy) || null;

        function setVal(id, val) {
          var el = document.getElementById(id);
          if (val != null) {
            el.textContent = val;
            el.className = 'rivo-debug__config-item__value';
          } else {
            el.textContent = 'not found';
            el.className = 'rivo-debug__config-item__value missing';
          }
        }

        setVal('cfg-proxy-loy', proxy);
        setVal('cfg-customer-id', cu.id || null);
        setVal('cfg-customer-email', cu.email || null);
        setVal('cfg-points', cu.points_tally != null ? cu.points_tally : null);

        document.getElementById('rivo-global-grid').style.display = 'grid';
        updateActionPreview();
        resetBtn(btn, 'Inspect again');
      } catch (e) {
        setJson('json-rivo-global', { error: e.message }, true);
        resetBtn(btn, 'Inspect again');
      }
    }, 100);
  }

  // ── 7. update_dob ─────────────────────────────────
  function runUpdateDob(btn) {
    if (!guardApi()) return;
    var dob = document.getElementById('dob-input').value.trim();
    var result = document.getElementById('dob-result');

    if (!/^\d{2}-\d{2}$/.test(dob)) {
      result.className = 'rivo-dob-result error';
      result.textContent = 'Format must be MM-DD (e.g. 06-24)';
      return;
    }

    setLoading(btn);
    result.className = 'rivo-dob-result';
    result.textContent = '';

    RivoAPI.update_dob('loggedin', dob)
      .then(function (resp) {
        result.className = 'rivo-dob-result success';
        result.textContent = '✅ DOB updated to ' + dob + '. Response: ' + JSON.stringify(resp);
        resetBtn(btn, 'Update DOB');
      })
      .catch(function (err) {
        result.className = 'rivo-dob-result error';
        result.textContent = '❌ ' + (err.message || String(err));
        resetBtn(btn, 'Update DOB');
      });
  }

  // ── 8. Custom action proxy ────────────────────────
  function getProxyUrl() {
    if (!window.Rivo) return null;
    var gc = window.Rivo.global_config || {};
    var proxy = gc.proxy_paths && gc.proxy_paths.loy;
    var customerId =
      window.Rivo.common &&
      window.Rivo.common.customer &&
      window.Rivo.common.customer.id;
    if (!proxy || !customerId) return null;
    return proxy + '/loy/customers/' + customerId + '/record_custom_action';
  }

  function updateActionPreview() {
    var url = getProxyUrl();
    var name = (document.getElementById('action-name-input').value) || 'YOUR_ACTION_NAME';
    var preview = document.getElementById('action-preview');
    if (url) {
      preview.textContent =
        'POST ' + url + '\n' + JSON.stringify({ custom_action_name: name }, null, 2);
      preview.className = 'rivo-debug__json';
      preview.style.color = '';
    } else {
      preview.textContent = '— inspect window.Rivo first to see the resolved URL —';
      preview.className = 'rivo-debug__json';
      preview.style.color = '#aaa';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var actionInput = document.getElementById('action-name-input');
    if (actionInput) actionInput.addEventListener('input', updateActionPreview);
  });

  function runCustomAction(btn) {
    var url = getProxyUrl();
    var name = document.getElementById('action-name-input').value.trim();
    var result = document.getElementById('action-result');

    if (!url) {
      result.className = 'rivo-action-result error';
      result.textContent = '❌ Cannot resolve proxy URL — run the window.Rivo inspector first.';
      return;
    }
    if (!name) {
      result.className = 'rivo-action-result error';
      result.textContent = '❌ Enter a custom action name.';
      return;
    }

    setLoading(btn);
    result.className = 'rivo-action-result';

    fetch(url, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ custom_action_name: name }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { status: response.status, data: data };
        });
      })
      .then(function (r) {
        if (r.status >= 200 && r.status < 300) {
          result.className = 'rivo-action-result success';
          result.textContent =
            '✅ Action "' + name + '" triggered (HTTP ' + r.status + '). Response: ' +
            JSON.stringify(r.data);
        } else {
          result.className = 'rivo-action-result error';
          result.textContent = '❌ HTTP ' + r.status + ': ' + JSON.stringify(r.data);
        }
        resetBtn(btn, 'Trigger');
      })
      .catch(function (err) {
        result.className = 'rivo-action-result error';
        result.textContent = '❌ ' + (err.message || String(err));
        resetBtn(btn, 'Trigger');
      });
  }

  // ── 9. referral_stats ─────────────────────────────
  function runGetCustomerReferrals(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.referral_stats('loggedin')
      .then(function (resp) {
        setJson('json-referrals', resp);
        RivoDebugComponents.renderReferrals(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-referrals', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 10. points_logs — Activity Feed ───────────────
  function runPointsLogs(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.points_logs('loggedin')
      .then(function (resp) {
        setJson('json-points-logs', resp);
        RivoDebugComponents.renderPointsLogs(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-points-logs', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 11. cart_earnings_estimation ───────────────────
  function runCartEarnings(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.cart_earnings_estimation()
      .then(function (resp) {
        setJson('json-cart-earnings', resp);
        RivoDebugComponents.renderCartEarnings(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-cart-earnings', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 12. best_reward_to_show ───────────────────────
  function runBestReward(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.best_reward_to_show('loggedin')
      .then(function (resp) {
        setJson('json-best-reward', resp);
        RivoDebugComponents.renderBestReward(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-best-reward', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 13. membership + membership_details ───────────
  function runMembership(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    Promise.all([
      RivoAPI.membership(),
      RivoAPI.membership_details()
    ])
      .then(function (results) {
        var combined = { membership: results[0], details: results[1] };
        setJson('json-membership', combined);
        RivoDebugComponents.renderMembership(combined);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-membership', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 14. loyalty_gifts ─────────────────────────────
  function runLoyaltyGifts(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.loyalty_gifts()
      .then(function (resp) {
        setJson('json-loyalty-gifts', resp);
        RivoDebugComponents.renderLoyaltyGifts(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-loyalty-gifts', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 15. profile_pos_qr ────────────────────────────
  function runPosQr(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.profile_pos_qr()
      .then(function (resp) {
        setJson('json-pos-qr', resp);
        RivoDebugComponents.renderPosQr(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-pos-qr', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 16. vip_tier — Full Roadmap ───────────────────
  function runVipTierRoadmap(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.vip_tier('loggedin')
      .then(function (resp) {
        setJson('json-vip-roadmap', resp);
        RivoDebugComponents.renderVipRoadmap(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-vip-roadmap', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 17. orders — Points per Order ─────────────────
  function runOrders(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.orders('loggedin', 10)
      .then(function (resp) {
        setJson('json-orders', resp);
        RivoDebugComponents.renderOrders(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-orders', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 18. shopify_customer ──────────────────────────
  function runShopifyCustomer(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.shopify_customer('loggedin')
      .then(function (resp) {
        setJson('json-shopify-customer', resp);
        RivoDebugComponents.renderShopifyCustomer(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-shopify-customer', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // ── 19. referrals — Full List ─────────────────────
  function runReferralsList(btn) {
    if (!guardApi()) return;
    setLoading(btn);
    RivoAPI.referrals('loggedin')
      .then(function (resp) {
        setJson('json-referrals-list', resp);
        RivoDebugComponents.renderReferralsList(resp);
        resetBtn(btn, 'Run again');
      })
      .catch(function (err) {
        setJson('json-referrals-list', { error: err.message || String(err) }, true);
        resetBtn(btn, 'Run again');
      });
  }

  // Public API — called from inline onclick attributes in the section HTML
  return {
    copyJson: copyJson,
    runGetCustomerDetails: runGetCustomerDetails,
    runGetVipTier: runGetVipTier,
    runGetShopRewards: runGetShopRewards,
    testRedeem: testRedeem,
    runInspectGlobal: runInspectGlobal,
    runUpdateDob: runUpdateDob,
    runCustomAction: runCustomAction,
    runGetCustomerReferrals: runGetCustomerReferrals,
    runPointsLogs: runPointsLogs,
    runCartEarnings: runCartEarnings,
    runBestReward: runBestReward,
    runMembership: runMembership,
    runLoyaltyGifts: runLoyaltyGifts,
    runPosQr: runPosQr,
    runVipTierRoadmap: runVipTierRoadmap,
    runOrders: runOrders,
    runShopifyCustomer: runShopifyCustomer,
    runReferralsList: runReferralsList,
  };
})();
